// extracted by mini-css-extract-plugin
export default {"FirstStarMessageContent":"FinishFirstStarMessage_FirstStarMessageContent__XNlDK","btnContainer":"FinishFirstStarMessage_btnContainer__6pInw"};